import {Role} from '../app/enum/role'
export const PATH_CONFIG = [
  {
    label: 'Estadísticas',
    modulo: 'ESTADISTICA',
    path: './estadistica/bilg',
    allowedRoles: [Role.ADMIN],
    options: [
      { label: 'Resumen Ejecutivo',     modulo: 'RESUMEN_EJECUTIVO',     allowedRoles: [Role.ADMIN], path: './estadistica/bilg' },
      { label: 'Ventas y Facturas',     modulo: 'VENTANAS_FACTURAS',     allowedRoles: [Role.ADMIN], path: './estadistica/bilg' },
      { label: 'Clientes',              modulo: 'ESTADISTICA_CLIENTE',   allowedRoles: [Role.ADMIN], path: './estadistica/bilg' },
      { label: 'Edades / Generaciones', modulo: 'EDADES_GENERACIONES',   allowedRoles: [Role.ADMIN], path: './estadistica/bilg' },
      { label: 'Almacenes',             modulo: 'ESTADISTICA_ALMACENES', allowedRoles: [Role.ADMIN], path: './estadistica/bilg' },
      { label: 'Proyecciones',          modulo: 'PROYECCIONES',          allowedRoles: [Role.ADMIN], path: './estadistica/bilg' },
      { label: 'RFM',                   modulo: 'RFM',                   allowedRoles: [Role.ADMIN], path: './estadistica/bilg' },
      { label: 'Insights Premium',      modulo: 'INSIGHTS_PREMIUM',      allowedRoles: [Role.ADMIN], path: './estadistica/bilg' },
    ]
  },
  {
    label: 'Mensajeria',
    modulo: 'MENSAJERIA',
    path: './estadistica/',
    allowedRoles: [Role.ADMIN],
    options: [
      {
        label: 'Mailing',
        modulo: 'MODULO_SIGMA',
        acciones: ['BUSCAR', 'ENVIAR'],
        allowedRoles: [Role.ADMIN],
        path: './estadistica/sendNotification'
      },
      {
        label: 'Estadisticas de envios',
        modulo: 'LISTA_CONTACTOS',
        allowedRoles: [Role.ADMIN],
        path: './estadistica/listContact'
      }
    ]
  },
  {
    label: 'Novedades',
    modulo: 'NOVEDADES',
    path: './almacen/',
    allowedRoles: [Role.ADMIN],
    options: [
      {
        label: 'Horarios Almacenes',
        modulo: 'HORARIO_ALMACENES',
        acciones: ['AGREGAR'],
        allowedRoles: [Role.ADMIN],
        path: './almacen/'
      }
    ]
  },
  {
    label: 'Facturas',
    modulo: 'FACTURAS',
    allowedRoles: [Role.CLIENTE, Role.ADMIN],
    path: './facturas/',
    options: [
      {
        label: 'Registro Ocr',
        modulo: 'REGISTRO_OCR',
        acciones: ['AGREGAR'],
        allowedRoles: [Role.CLIENTE, Role.ADMIN],
        path: './facturas/register'
      },
      {
        label: 'Facturas Pendientes',
        modulo: 'FACTURAS_PENDIENTES',
        allowedRoles: [Role.ADMIN],
        path: './facturas/getBillsPending'
      },
      {
        label: 'Facturas Ocr',
        modulo: 'FACTURAS_OCR',
        allowedRoles: [Role.ADMIN],
        path: './facturas/getBills'
      },
      {
        label: 'Consultar Boletas',
        modulo: 'CONSULTAR_BOLETAS',
        allowedRoles: [Role.ADMIN],
        path: './facturas/consultTicket'
      }
    ]
  },
  {
    label: 'FPQRS',
    allowedRoles: [Role.CLIENTE],
    path: './fpqrs/',
    options: [
      {
        label: 'Registro FPQRS',
        allowedRoles: [Role.CLIENTE],
        path: './fpqrs/'
      }
    ]
  },
  {
    label: 'Cliente',
    modulo: 'CLIENTES',
    allowedRoles: [Role.ADMIN],
    path: './client/',
    options: [
      {
        label: 'Buscar Clientes',
        modulo: 'BUSCAR_CLIENTES',
        acciones: ['BUSCAR', 'AGREGAR'],
        allowedRoles: [Role.ADMIN],
        path: './client/listClient'
      },
      {
        label: 'Lista Negra',
        modulo: 'LISTA_NEGRA',
        acciones: ['BUSCAR'],
        allowedRoles: [Role.ADMIN],
        path: './client/listaNegra'
      }
    ]
  },
  {
    label: 'Comercial',
    modulo: 'COMERCIAL',
    allowedRoles: [Role.ADMIN],
    path: './comercial/',
    options: [
      {
        label: 'Buscar Stands',
        modulo: 'BUSCAR_STANDS',
        acciones: ['BUSCAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './comercial/stand'
      }
    ]
  },
  {
    label: 'Almacenes',
    modulo: 'ALMACENES',
    allowedRoles: [Role.ADMIN],
    path: './almacen/listAlmacenes',
    options: [
      {
        label: 'Listar Almacenes',
        modulo: 'LISTAR_ALMACENES',
        allowedRoles: [Role.ADMIN],
        path: './almacen/listAlmacenes'
      }
    ]
  },
  {
    label: 'Admin',
    modulo: 'ADMIN',
    allowedRoles: [Role.ADMIN],
    path: './admin/',
    options: [
      {
        label: 'Plantillas',
        modulo: 'PLANTILLAS',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/plantillas'
      },
      {
        label: 'Plantillas de Boleta',
        modulo: 'PLANTILLAS_BOLETA',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/plantillasBoleta'
      },
      {
        label: 'Roles',
        modulo: 'ROLES',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/roles'
      },
      {
        label: 'Modulos',
        modulo: 'MODULOS',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/modulos'
      },
      {
        label: 'Acciones',
        modulo: 'ACCIONES',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/acciones'
      },
      {
        label: 'Referencias',
        modulo: 'REFERENCIAS',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/referencias'
      },
      {
        label: 'Permisos',
        modulo: 'PERMISOS',
        acciones: ['ASIGNAR', 'EDITAR', 'ELIMINAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/permisos'
      },
      {
        label: 'Roles Usuario',
        modulo: 'ROLES_USUARIO',
        acciones: ['BUSCAR', 'CAMBIAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/permisos/roles-usuario'
      },
      {
        label: 'Módulos por Mall',
        modulo: 'MODULOS_CENTROCOMERCIAL',
        acciones: ['BUSCAR', 'ASIGNAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/permisos/modulos-centro-comercial'
      },
      {
        label: 'Centros Comerciales',
        soloSuperAdmin: true,
        allowedRoles: [Role.ADMIN],
        path: './admin/centroComercial'
      },
      {
        label: 'Configuración de Correos',
        soloSuperAdmin: true,
        allowedRoles: [Role.ADMIN],
        path: './admin/configuracionCorreo'
      },
      {
        label: 'Envíos de Correo',
        modulo: 'CORREO_ENVIO_LOG',
        acciones: ['BUSCAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/correoEnvioLog'
      },
      {
        label: 'Horario y Festivos (Ley 2300)',
        soloSuperAdmin: true,
        allowedRoles: [Role.ADMIN],
        path: './admin/ley2300'
      },
      {
        label: 'Facturas Eliminadas',
        soloSuperAdmin: true,
        allowedRoles: [Role.ADMIN],
        path: './admin/facturasEliminadas'
      },
      {
        label: 'Clientes Duplicados',
        modulo: 'CLIENTES_DUPLICADOS',
        acciones: ['BUSCAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/clientesDuplicados'
      },
      {
        label: 'Novedades',
        modulo: 'NOVEDADES',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/novedades'
      },
      {
        label: 'Catálogo de Equipos',
        modulo: 'PRESTAMOS_EQUIPOS',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR', 'ELIMINAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/prestamosEquipos'
      },
      {
        label: 'Actividades',
        modulo: 'ACTIVIDADES',
        acciones: ['BUSCAR', 'AGREGAR', 'EDITAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/actividades'
      },
      {
        label: 'GoPass (Parqueadero)',
        modulo: 'GOPASS',
        acciones: ['BUSCAR', 'AGREGAR'],
        allowedRoles: [Role.ADMIN],
        path: './admin/gopass'
      }
    ]
  },
  {
    label: 'Ruleta',
    soloSuperAdmin: true,
    allowedRoles: [Role.ADMIN],
    path: './admin/ruleta'
  },
  {
    label: 'Club de Fidelización',
    modulo: 'CLUB_FIDELIZACION',
    acciones: ['BUSCAR', 'AGREGAR', 'EDITAR', 'ELIMINAR'],
    allowedRoles: [Role.ADMIN],
    path: './admin/clubFidelizacion'
  },
  {
    label: 'Premios Instantáneos',
    modulo: 'PREMIOS_INSTANTANEOS',
    acciones: ['BUSCAR', 'AGREGAR', 'EDITAR', 'ELIMINAR'],
    allowedRoles: [Role.ADMIN],
    path: './admin/premiosInstantaneos'
  },
  {
    label: 'Solicitudes',
    modulo: 'SOLICITUDES',
    allowedRoles: [Role.ADMIN],
    path: './solicitudes/',
    options: [
      {
        label: 'Solicitudes',
        modulo: 'SOLICITUDES',
        acciones: ['BUSCAR'],
        allowedRoles: [Role.ADMIN],
        path: './solicitudes/listar'
      },
      {
        label: 'Áreas',
        modulo: 'SOLICITUDES',
        acciones: ['CONFIGURAR'],
        allowedRoles: [Role.ADMIN],
        path: './solicitudes/config/areas'
      },
      {
        label: 'Categorías',
        modulo: 'SOLICITUDES',
        acciones: ['CONFIGURAR'],
        allowedRoles: [Role.ADMIN],
        path: './solicitudes/config/categorias'
      },
      {
        label: 'Tipos de Solicitud',
        modulo: 'SOLICITUDES',
        acciones: ['CONFIGURAR'],
        allowedRoles: [Role.ADMIN],
        path: './solicitudes/config/tipos'
      },
      {
        label: 'Flujos de Aprobación',
        modulo: 'SOLICITUDES',
        acciones: ['CONFIGURAR'],
        allowedRoles: [Role.ADMIN],
        path: './solicitudes/config/flujos'
      },
      {
        label: 'Contratistas',
        modulo: 'SOLICITUDES',
        acciones: ['CONFIGURAR'],
        allowedRoles: [Role.ADMIN],
        path: './solicitudes/config/contratistas'
      },
      {
        label: 'Personas',
        modulo: 'SOLICITUDES',
        acciones: ['CONFIGURAR'],
        allowedRoles: [Role.ADMIN],
        path: './solicitudes/config/personas'
      },
      {
        label: 'Vehículos',
        modulo: 'SOLICITUDES',
        acciones: ['CONFIGURAR'],
        allowedRoles: [Role.ADMIN],
        path: './solicitudes/config/vehiculos'
      }
    ]
  },
  {
    label: 'Cuponera',
    modulo: 'CUPONERA',
    allowedRoles: [Role.ADMIN, Role.ALMACEN, Role.CLIENTE],
    path: './cupones/',
    options: [
      {
        label: 'Cupones',
        modulo: 'CUPONES',
        allowedRoles: [Role.ADMIN],
        path: './cupones/'
      },
      {
        label: 'Emisiones',
        modulo: 'EMISIONES',
        allowedRoles: [Role.ADMIN],
        path: './cupones/emisiones'
      },
      {
        label: 'Panel Marca',
        modulo: 'PANEL_MARCA',
        allowedRoles: [Role.ADMIN, Role.ALMACEN],
        path: './cupones/marca'
      },
      {
        label: 'Mis Cupones',
        modulo: 'MIS_CUPONES',
        allowedRoles: [Role.CLIENTE],
        path: './cupones/mis-cupones'
      }
    ]
  }
]
